import { map, pipe } from 'rxjs';

import { createSelector } from '@ngrx/store';

import { getRoles } from '@schaeffler/azure-auth';

import { adminRoles, RolePrefix } from '@cdba/core/auth/config/auth.config';
import { RoleDescriptions } from '@cdba/core/auth/models/roles.models';

import { selectRolesState } from '../../reducers';
import { RolesState } from '../../reducers/roles/roles.reducer';

export const getRoleDescriptions = createSelector(
  selectRolesState,
  (state: RolesState): RoleDescriptions => state.roleDescriptions.items
);

export const getRoleDescriptionsLoaded = createSelector(
  selectRolesState,
  (state: RolesState) => state.roleDescriptions.loaded
);

export const getRoleDescriptionsErrorMessage = createSelector(
  selectRolesState,
  (state: RolesState) => state.roleDescriptions.errorMessage
);

export const getHasDescriptiveRoles = pipe(
  getRoles,
  map((roles): boolean => {
    if (roles.some((role) => adminRoles.includes(role))) {
      return true;
    }

    const plRoles = roles.filter((role) =>
      role.startsWith(RolePrefix.ProductLine)
    );
    const srRoles = roles.filter((role) =>
      role.startsWith(RolePrefix.SubRegion)
    );

    return plRoles.length > 0 && srRoles.length > 0;
  })
);
